export default {
  toasts: {
    load_error: 'Impossibile caricare le fatture.',
    action_error: 'Azione non riuscita — riprova.',
    finalized: 'Fattura finalizzata.',
    marked_paid: 'Fattura contrassegnata come pagata.',
  },
  filters: {
    status: 'Filtra per stato',
  },
  volume_discount_badge: 'Sconto volume applicato ({{licenses}} licenze, {{percent}}%)',
  columns: {
    description: 'Fattura',
    status: 'Stato',
    total: 'Totale',
    paid_at: 'Pagata il',
  },
  statuses: {
    pending: 'In attesa',
    processing: 'In elaborazione',
    paid: 'Pagata',
    failed: 'Fallita',
    refunded: 'Rimborsata',
    partially_refunded: 'Parzialmente rimborsata',
  },
  companies: {
    partner_level: 'Modifiche a livello di partner',
    columns: {
      company: 'Ristorante',
      buckets: 'Voci',
      amount: 'Importo',
    },
  },
  buckets: {
    license_fees: 'Costi di licenza',
    service_fees: 'Commissioni di servizio',
    processing_fees: 'Commissioni di elaborazione',
    delivery_fees: 'Commissioni di consegna',
    gift_card_fees: 'Commissioni gift card',
    adjustments: 'Rettifiche',
  },
  entries: {
    count: '{{count}} voci',
    columns: {
      description: 'Voce',
      occurred_at: 'Data',
      amount: 'Importo',
    },
  },
  incl_tax: 'incl. {{amount}} IVA',
  actions: {
    open_invoice_pdf: 'Scarica fattura (PDF)',
    open_hosted: 'Apri fattura su Stripe',
    export_csv: 'Esporta CSV',
    finalize: 'Finalizza su Stripe',
    mark_paid: 'Segna come pagata',
  },
  finalize: {
    title: 'Finalizzare questa fattura su Stripe?',
    description:
      "Finalizzando si avvia la riscossione: con un metodo di pagamento salvato l'addebito avviene automaticamente, altrimenti il partner riceve la fattura ospitata.",
    confirm: 'Finalizza',
  },
  mark_paid: {
    pushed_note:
      'Questa fattura è già su Stripe — la bozza verrà eliminata (o una fattura finalizzata contrassegnata come pagata fuori banda) in modo che Stripe smetta di riscuotere.',
    title: 'Contrassegnare questa fattura come pagata?',
    description:
      'Registra un pagamento manuale (offline) di {{amount}}. Usalo per bonifici bancari incassati fuori da Stripe.',
    confirm: 'Segna come pagata',
  },
  settlement_badge: {
    paid: 'Quota ricavi versata: {{amount}}',
    other: 'Pagamento quota ricavi {{amount}} · {{status}}',
  },
  settlements: {
    title: 'Pagamenti quota ricavi',
    retry: 'Riprova',
    toasts: {
      load_error: 'Impossibile caricare i pagamenti.',
      retry_error: 'Il nuovo tentativo non è riuscito: riprova.',
      retry_paid: 'Quota ricavi versata.',
      retry_attempted: 'Nuovo tentativo eseguito: il pagamento non è ancora concluso, controlla lo stato.',
    },
    columns: {
      period: 'Periodo',
      amount: 'Importo',
      status: 'Stato',
      transfer: 'Trasferimento',
      paid_at: 'Pagata il',
      payout: 'Pagamento',
    },
    payout: {
      direct: '{{amount}}, nessuna conversione',
      direct_tooltip:
        "Dovuto {{owed}}, convertito a 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}} e inviato così com'è: nessuna conversione Stripe, nessuna commissione.",
      converted: 'Inviato {{sent}} → arrivato {{arrived}}',
      expected: 'Inviato {{sent}} → previsto {{arrived}}',
      fee: 'Commissione di conversione Stripe {{amount}}',
      net: 'netto {{amount}}',
      pending_details: 'La commissione e il netto vengono visualizzati una volta che Stripe completa il trasferimento.',
      tooltip:
        "Dovuto {{owed}}. Convertito a 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}}, inviato dal saldo della piattaforma in {{source_currency}} e convertito da Stripe a 1 {{source_currency}} = {{stripe_rate}} {{payout_currency}}. Stripe detrae il {{fee_rate}}% all'arrivo.",
    },
    statuses: {
      pending: 'In attesa',
      held: 'In sospeso',
      processing: 'In elaborazione',
      paid: 'Versato',
      failed: 'Fallita',
      reversed: 'Storno',
    },
    hold_reasons: {
      kyc_incomplete: "Il partner non ha ancora completato la verifica dell'account di pagamento.",
      transfers_inactive: "L'account di pagamento non può ancora ricevere trasferimenti.",
      insufficient_platform_balance: 'Il saldo della piattaforma non copre al momento questo pagamento.',
      manual_hold: 'In sospeso manualmente.',
      missing_fx_rate:
        'Non è ancora memorizzato alcun tasso di cambio per la valuta di pagamento. Viene ritentato automaticamente.',
      unsupported_payout_currency:
        'Stripe non può erogare questo pagamento nella valuta del conto di pagamento dal saldo della piattaforma.',
      amount_too_small: "L'importo dovuto è inferiore al trasferimento minimo di Stripe per questa valuta.",
    },
  },
};
